import React, { useState } from 'react';
import './JobFilters.css';

const JobFilters = ({ filters, onFilterChange, onClearFilters, onApplyFilters, jobCount, isHorizontal = false, hideHeader = false, onSavePreference = null }) => {
  const [expandedSections, setExpandedSections] = useState({
    jobType: true,
    workType: true,
    experience: true,
    salary: true,
    location: true,
    datePosted: true,
    company: true,
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };



  const hasActiveFilters = () => {
    return (
      (filters.jobType && filters.jobType !== '') ||
      (filters.workType && filters.workType !== '') ||
      (filters.experienceLevel && filters.experienceLevel !== '') ||
      (filters.location && filters.location.trim() !== '') ||
      (filters.datePosted && filters.datePosted !== 'all')
    );
  };

  return (
    <div className={`job-filters ${isHorizontal ? 'job-filters-horizontal' : ''}`}>
      {!isHorizontal && !hideHeader && (
        <>
          <div className="job-filters-header">
            <h3>Filters</h3>
            {hasActiveFilters() && (
              <button 
                className="job-filters-clear-btn"
                onClick={onClearFilters}
              >
                Clear all
              </button>
            )}
          </div>

          {jobCount !== null && (
            <div className="job-filters-count">
              {jobCount} {jobCount === 1 ? 'job' : 'jobs'} found
            </div>
          )}
        </>
      )}

      {/* Location Filter - First Priority */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Location</span>
        </label>
        <input
          type="text"
          placeholder="City, Country, or Remote"
          value={filters.location || ''}
          onChange={(e) => onFilterChange('location', e.target.value)}
          className="job-filter-text-input"
        />
      </div>

      {/* Job Type Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Job Type</span>
        </label>
        <select
          className="job-filter-dropdown"
          value={filters.jobType || ''}
          onChange={(e) => onFilterChange('jobType', e.target.value)}
        >
          <option value="">Select...</option>
          {['full-time', 'part-time', 'contract', 'freelance', 'internship'].map(type => (
            <option key={type} value={type}>
              {type.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('-')}
            </option>
          ))}
        </select>
      </div>

      {/* Work Type Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Work Type</span>
        </label>
        <select
          className="job-filter-dropdown"
          value={filters.workType || ''}
          onChange={(e) => onFilterChange('workType', e.target.value)}
        >
          <option value="">Select...</option>
          {['remote', 'hybrid', 'on-site'].map(type => (
            <option key={type} value={type}>
              {type.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('-')}
            </option>
          ))}
        </select>
      </div>

      {/* Experience Level Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Experience</span>
        </label>
        <select
          className="job-filter-dropdown"
          value={filters.experienceLevel || ''}
          onChange={(e) => onFilterChange('experienceLevel', e.target.value)}
        >
          <option value="">Select...</option>
          {[
            { value: 'entry', label: 'Entry Level' },
            { value: 'mid', label: 'Mid Level' },
            { value: 'senior', label: 'Senior Level' },
            { value: 'executive', label: 'Executive' }
          ].map(level => (
            <option key={level.value} value={level.value}>
              {level.label}
            </option>
          ))}
        </select>
      </div>

      {/* Date Posted Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Date Posted</span>
        </label>
        <select
          className="job-filter-dropdown"
          value={filters.datePosted || 'all'}
          onChange={(e) => onFilterChange('datePosted', e.target.value)}
        >
          <option value="all">All time</option>
          <option value="24h">Past 24 hours</option>
          <option value="week">Past week</option>
          <option value="month">Past month</option>
        </select>
      </div>

      {/* Search/Apply Button */}
      {onApplyFilters && (
        <div className={`job-filter-section ${isHorizontal ? 'job-filter-apply-section-horizontal' : 'job-filter-apply-section-vertical'}`}>
          {isHorizontal && (
            <label className="job-filter-section-header">
              <span>Search</span>
            </label>
          )}
          <div style={{
            display: 'flex',
            flexDirection: isHorizontal ? 'row' : 'column',
            gap: isHorizontal ? '12px' : '12px',
            width: isHorizontal ? 'auto' : '100%',
            alignItems: isHorizontal ? 'flex-end' : 'stretch'
          }}>
            <button 
              className="job-filters-apply-btn"
              onClick={onApplyFilters}
              style={isHorizontal ? { marginTop: 0, width: 'auto', minWidth: '150px' } : {}}
            >
              {!isHorizontal && (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              )}
              {isHorizontal ? 'Search' : 'Search Jobs'}
            </button>
            {hasActiveFilters() && onSavePreference && (
              <button 
                className="job-filters-save-preference-btn"
                onClick={onSavePreference}
                style={{
                  padding: '10px 20px',
                  background: 'transparent',
                  color: '#7a5fb8',
                  border: '1px solid #7a5fb8',
                  borderRadius: '8px',
                  fontSize: isHorizontal ? '13px' : '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  width: isHorizontal ? 'auto' : '100%',
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                  minWidth: isHorizontal ? '150px' : 'auto'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f5f3ff';
                  e.target.style.borderColor = '#6b4fa0';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.borderColor = '#7a5fb8';
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                </svg>
                Save Preference
              </button>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default JobFilters;

